import type { FlowCardDefinition } from '../types';

function timerCard(debounce: boolean): FlowCardDefinition {
	return {
		type: 'timer',
		...(debounce ? { paletteKey: 'debounceTimer' } : {}),
		version: '1.0.0',
		domain: 'core',
		role: 'utility',
		category: 'specialCards',
		label: debounce ? 'Debounce Timer' : 'Timer',
		description: debounce
			? 'Wait before running the next action (default 30 seconds)'
			: 'Wait for a chosen duration before continuing to the next action',
		icon: debounce ? 'fa-stopwatch' : 'fa-hourglass-half',
		color: '#8b5cf6',
		schema: {
			$schema: 'https://json-schema.org/draft/2020-12/schema',
			type: 'object',
			required: ['timerMode', 'delay'],
			properties: {
				timerMode: { type: 'string', enum: ['delay'] },
				delay: {
					type: 'object',
					required: ['value', 'units'],
					properties: {
						value: { type: 'number', minimum: 0 },
						units: { type: 'string', enum: ['sec', 'min'] },
					},
				},
			},
		},
		fields: [
			{ path: 'delay.value', label: 'Duration', type: 'number', min: 0, max: 1440, step: 1 },
			{
				path: 'delay.units',
				label: 'Unit',
				type: 'select',
				options: [
					{ value: 'sec', label: 'Seconds' },
					{ value: 'min', label: 'Minutes' },
				],
			},
		],
		ports: { sources: ['output'] },
		defaults: () => ({
			timerMode: 'delay',
			delay: { value: debounce ? 30 : 0, units: 'sec' },
			cardVersion: '1.0.0',
		}),
		summary: (data) => {
			const value = Number(data.delay?.value || 0);
			const unit = data.delay?.units === 'min' ? 'min' : 'sec';
			return value > 0 ? `Wait ${value} ${unit}` : 'Set a duration';
		},
		validate: (data) =>
			Number(data.delay?.value) > 0
				? []
				: [{ path: 'delay.value', message: 'Set delay duration' }],
		compile: (node) => ({
			wait: Number(node.data.delay?.value || 0),
			units: node.data.delay?.units === 'min' ? 'minutes' : 'sec',
			_fid: node.id,
			_flow_card: String(node.data.paletteKey || (debounce ? 'debounceTimer' : 'timer')),
			_flow_card_version: '1.0.0',
		}),
		migrate: (data) => ({
			...data,
			timerMode: 'delay',
			delay: {
				value: Number((data.delay as any)?.value ?? data.wait ?? (debounce ? 30 : 0)),
				units: (data.delay as any)?.units === 'min' || data.units === 'minutes' ? 'min' : 'sec',
			},
		}),
	};
}

export const timerCards = [timerCard(false), timerCard(true)];
